const prefix = 'user-profile';

const SET_BASIC_INFO = `${prefix}/SET_BASIC_INFO`;

const SET_LOADING = `${prefix}/SET_LOADING`;

const RESET = `${prefix}/RESET`;

export { SET_BASIC_INFO, RESET, SET_LOADING };
